import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useState } from "react";

export default function TrialBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("coachiq_trial_dismissed") === "1");
  if (!user || dismissed) return null;
  const plan = user.plan;
  if (plan === "coach_pro" || plan === "club" || plan === "enterprise") return null;
  if (user.is_founder) return null; // Founders don't see the trial nag
  const days = user.trial_days_left;
  if (days == null) return null;

  const urgent = days <= 5;
  const bg = urgent ? "bg-amber-50 border-amber-200 text-amber-900" : "bg-blue-50 border-blue-200 text-blue-900";
  const dot = urgent ? "bg-amber-500" : "bg-blue-500";
  const dismiss = () => { sessionStorage.setItem("coachiq_trial_dismissed", "1"); setDismissed(true); };

  return (
    <div className={`rounded-2xl border ${bg} px-4 py-2.5 flex items-center gap-3 mb-4`} data-testid="trial-banner">
      <span className={`w-2 h-2 rounded-full ${dot}`} />
      <div className="text-sm flex-1">
        <span className="font-semibold">{days === 0 ? "Trial ends today" : days === 1 ? "1 day left in trial" : `${days} days left in your Coach Pro trial`}</span>
        {" · "}
        <span className="opacity-80">Every feature stays free during the Beta. </span>
        <Link to="/pricing" className="font-semibold underline underline-offset-2 hover:opacity-80" data-testid="trial-banner-cta">See plans →</Link>
      </div>
      <button onClick={dismiss} data-testid="trial-banner-dismiss" className="opacity-60 hover:opacity-100"><X className="w-4 h-4" /></button>
    </div>
  );
}
